<script>
/* global google */
import { getCurrentAddress } from '../utils/helpers'

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      marker: null,
      markerIcon: {
        url: require('../static/marker.png'),
        alt: 'marker icon',
      },
    }
  },
  async mounted() {
    this.initilizeListner()
  },
  methods: {
    initilizeListner() {
      if (this.map) {
        const self = this
        this.google.maps.event.addListener(this.map, 'dblclick', (e) => {
          this.$emit('loading', true)
          self.placeMarkerOnMap(e.latLng)
          getCurrentAddress(e.latLng)
            .then((result) => {
              this.$emit('double-click', result)
            })
            .finally(() => {
              this.$emit('loading', false)
            })
        })
      }
    },
    placeMarkerOnMap(_latLng) {
      this.removeMarker()
      this.marker = new google.maps.Marker({
        position: {
          lat: _latLng.lat(),
          lng: _latLng.lng(),
        },
        map: this.map,
        icon: this.markerIcon,
      })
    },
    removeMarker() {
      if (this.marker) {
        this.marker.setMap(null)
      }
    },
  },
}
</script>

<template><div></div></template>
